import { Routes } from '@angular/router';
import { ROUTING } from './core/constants/routing.constants';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./wall/wall.routes').then((m) => m.WALL_ROUTES),
  },
  {
    path: ROUTING.PHONE_NUMBER,
    loadChildren: () =>
      import('./phone-number/phone-number.routes').then((m) => m.PHONE_NUMBER_ROUTES),
  },
  {
    path: ROUTING.PHONE_NUMBER_OTP,
    loadChildren: () =>
      import('./phone-number-otp/phone-number-otp.routes').then((m) => m.PHONE_NUMBER_OTP_ROUTES),
  },
  {
    path: ROUTING.EDO_APP_EID,
    loadChildren: () => import('./edo-app/edo-app.routes').then((m) => m.EDO_APP_ROUTES),
  },
  {
    path: ROUTING.EDO_APP_VERIFICATION,
    loadChildren: () => import('./edo-app/edo-app.routes').then((m) => m.EDO_APP_ROUTES),
  },
  {
    path: ROUTING.M_OBYWATEL,
    loadChildren: () => import('./m-obywatel/m-obywatel.routes').then((m) => m.MOBYWATEL_ROUTES),
  },
  {
    path: ROUTING.FREE_SIGNATURES,
    loadChildren: () =>
      import('./free-signatures/free-signatures.routes').then((m) => m.FREE_SIGNATURES_ROUTES),
  },
  {
    path: ROUTING.FREE_SIGNATURES_COMMERCIAL,
    loadChildren: () =>
      import('./free-signatures/free-signatures.routes').then((m) => m.FREE_SIGNATURES_ROUTES),
  },
  {
    path: ROUTING.SERVICE_UNAVAILABLE,
    loadComponent: () =>
      import('./service-unavailable/service-unavailable.component').then(
        (m) => m.ServiceUnavailableComponent
      ),
  },
];
